import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AppState } from 'src/store/store';
import guidesApiService from 'src/api/services/guidesApiService';
import { DocumentTypesState } from './types';
import { notification } from 'antd';

const initialState: DocumentTypesState = {
    isLoading: false,
    items: []
};

export const loadDocumentTypesAsync = createAsyncThunk('documentTypes/load', async () => {
    try {
        const data = await guidesApiService.getDocumentTypes();
        return data;
    } catch (error) {
        if (error instanceof Error) {
            notification.error({ message: error.message });
            throw error;
        }
        throw new Error();
    }
});

const slice = createSlice({
    name: 'documentTypes',
    initialState,
    reducers: {
        reset: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadDocumentTypesAsync.pending, (state) => {
                state.isLoading = true;
                state.items = [];
            })
            .addCase(loadDocumentTypesAsync.fulfilled, (state, action) => {
                state.isLoading = false;
                state.items = action.payload;
            })
            .addCase(loadDocumentTypesAsync.rejected, (state) => {
                state.isLoading = false;
            });
    }
});

export const { reset } = slice.actions;

const selectDocumentTypes = (state: AppState) => state.documentTypes;

export const selectItems = (state: AppState) => selectDocumentTypes(state).items;

export const selectIsLoading = (state: AppState) => selectDocumentTypes(state).isLoading;

export default slice.reducer;
